import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";

import { Dept, DeptDetail } from "../../../models/dept.model";

import Shop from "../../../models/shop.model";
import * as XLSX from "xlsx";

@Component({
  selector: "ngx-layout-dept-detail-tamtax",
  templateUrl: "layout-dept-detail-tamtax.component.html",
  styleUrls: ["layout-dept-detail-tamtax.component.scss"],
})
export class LayoutPrintDeptDetailTamTaxComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() shop?: Shop;
  @Input() object?: any;
  @Input() mode?: string; //customer / supplier
  @Input() type?: string = "print"; //print / export
  @Input() fromDate?: Date = new Date();
  @Input() toDate?: Date = new Date();

  @Input() deptDetail?: DeptDetail[] = [];
  @Input() paymentDebits?: Dept[] = [];
  @Input() initAmount?: number;
  @Input() lastAmount?: number;
  @Input() saleAmount?: number;
  @Input() paidAmount?: number;
  @Input() debitAmount?: number;
  @Input() discountAmount?: number;
  @Output() onExport: EventEmitter<any> = new EventEmitter();

  loading = false;
  printing = false;
  displayName = "";
  currentDate: Date = new Date();

  @ViewChild("exportTable") exportTable: ElementRef;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.type === "export") {
        this.exportToExcel();
      }
    }, 1000);
  }

  print() {
    this.printing = true;
  }

  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.exportTable.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Dept");

    /* save to file */
    XLSX.writeFile(wb, "SheetJS.xlsx");

    this.onExport.emit(true);
  }
}
